import React from 'react';

interface DateFieldProps {
  label: string;
  value: string | null;
  onChange: (value: string | null) => void;
  isEditing: boolean;
  formatter: (date: string) => string;
  nullable?: boolean;
}

export const DateField: React.FC<DateFieldProps> = ({
  label,
  value,
  onChange,
  isEditing,
  formatter,
  nullable = false,
}) => {
  return (
    <div className='flex justify-between items-center'>
      <span className='text-gray-600'>{label}:</span>
      {isEditing ? (
        <input
          type='date'
          value={value || ''}
          onChange={(e) => onChange(nullable && !e.target.value ? null : e.target.value)}
          className='text-xs px-2 py-1 border border-gray-300 rounded'
        />
      ) : (
        <span className='font-medium text-gray-800'>
          {value ? formatter(value) : 'N/A'}
        </span>
      )}
    </div>
  );
};
